import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL, DOWNLOAD_URL } from '../constants'
import { PageWrapper, PageLoader, Button } from '../components'
import 'react-table/react-table.css'
import { isEmpty, get } from 'lodash'
import { createGlobalStyle } from 'styled-components'
import FileDownload from 'js-file-download'
import moment from 'moment'
const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }
`
class ViewUsers extends Component {
  state = { loader: false, users: [], isCsvLoading: false }
  componentDidMount() {
    this.getUsers()
  }

  getUsers = async () => {
    try {
      const { data } = await axios.post(`${API_URL}/users/getUsers`, {
        csv: 'false'
      })
      this.setState({ users: data })
    } catch (error) {
      console.log(error)
    }
  }

  handleCsv = async () => {
    this.setState({ isCsvLoading: true })
    try {
      const { data } = await axios.post(`${API_URL}/users/getUsers`, {
        csv: 'true'
      })
      FileDownload(data, 'users.csv')
      this.setState({ isCsvLoading: false })
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    const { users, isCsvLoading } = this.state

    return (
      <React.Fragment>
        <GlobalStyle />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px">
          <TableWrap>
            <ReactTable
              data={users}
              columns={[
                {
                  // Header: 'ID',
                  Header: row => {
                    return (
                      <React.Fragment>
                        <div>ID</div>
                        <Button
                          style={{
                            border: '1px solid #fff',
                            borderRadius: 4,
                            padding: 2,
                            marginTop: 1,
                            height: 22,
                            fontSize: 11
                          }}
                          size="small"
                          label="Export Csv"
                          isLoading={isCsvLoading}
                          disabled={isCsvLoading}
                          onClick={this.handleCsv}
                        />
                      </React.Fragment>
                    )
                  },
                  accessor: 'id',
                  width: 150
                },
                {
                  Header: 'Name',
                  accessor: 'name',
                  width: 150
                },
                {
                  Header: 'Email',
                  accessor: 'email',
                  width: 200
                },
                {
                  Header: 'Source',
                  accessor: 'source',
                  width: 100
                },
                {
                  Header: 'Diets',
                  accessor: 'diets',
                  width: 300
                },
                {
                  Header: 'Allergies',
                  accessor: 'allergies',
                  width: 300
                },
                {
                  Header: 'Processing',
                  accessor: 'gsCategoryWeightProcessing',
                  width: 80
                },
                {
                  Header: 'Nutrition',
                  accessor: 'gsCategoryWeightNutrition',
                  width: 70
                },
                {
                  Header: 'FoodSafety',
                  accessor: 'gsCategoryWeightFoodSafety',
                  width: 80
                },
                {
                  Header: 'AnimalWelfare',
                  accessor: 'gsCategoryWeightAnimalWelfare',
                  width: 100
                },
                {
                  Header: 'HumanRights',
                  accessor: 'gsCategoryWeightHumanRights',
                  width: 100
                },
                {
                  Header: 'Environment',
                  accessor: 'gsCategoryWeightEnvironment',
                  width: 90
                },
                {
                  Header: 'Transparency',
                  accessor: 'gsCategoryWeightTransparency',
                  width: 100
                },
                {
                  Header: 'zip Code',
                  accessor: 'zipCode',
                  width: 80
                },
                {
                  Header: 'profileImage',
                  Cell: row =>
                    isEmpty(get(row.original, 'profileImage', '')) ? (
                      <img src={require('../static/images/no-image.png')} height="100px" alt={'demo'} />
                    ) : (
                      <img
                        src={`${DOWNLOAD_URL}/${get(row.original, 'profileImage', '')}`}
                        height="100px"
                        alt={get(row.original, 'name', '')}
                      />
                    ),
                  width: 180
                },
                {
                  Header: 'Referral Code',
                  accessor: 'referralCode',
                  width: 100
                },
                {
                  Header: 'Referred By',
                  accessor: 'referredUser',
                  width: 100
                },
                {
                  Header: 'Timestamp',
                  accessor: 'createdAt',
                  Cell: row =>
                    row.original.createdAt
                      ? moment(get(row.original, 'createdAt', '')).format('DD MMM YYYY HH:mm:ss')
                      : '',
                  minWidth: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
      </React.Fragment>
    )
  }
}
export default ViewUsers



// WEBPACK FOOTER //
// ./src/pages/ViewUsers.js